import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "content-card-actions" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["src"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "text-caption" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_Markdown = _resolveComponent("Markdown")!
  const _component_CodeBlock = _resolveComponent("CodeBlock")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.title != null)
      ? (_openBlock(), _createBlock(_component_v_card_title, {
          key: 0,
          class: "pa-4"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
            _createElementVNode("div", _hoisted_1, [
              (_ctx.show)
                ? (_openBlock(), _createBlock(_component_v_expansion_panels, {
                    key: 0,
                    density: "compact",
                    variant: "default",
                    class: "formatting-expander mr-2 mt-n1 py-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_expansion_panel, {
                        elevation: "1",
                        "min-height": "32px",
                        "bg-color": "background"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_expansion_panel_title, {
                            class: "text-caption py-0 px-2 ma-0",
                            "min-height": "32px"
                          }, {
                            default: _withCtx(() => _cache[3] || (_cache[3] = [
                              _createTextVNode(" Formatting ")
                            ])),
                            _: 1,
                            __: [3]
                          }),
                          _createVNode(_component_v_expansion_panel_text, { class: "pa-0 mx-0" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_checkbox, {
                                modelValue: _ctx.addBackticks,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.addBackticks) = $event)),
                                label: "Add Backticks",
                                "hide-details": "",
                                class: "checkbox text-caption d-block mx-0",
                                density: "compact"
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_v_radio_group, {
                                class: "formatting-options pa-0 mx-0",
                                inline: "",
                                modelValue: _ctx.formatting,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formatting) = $event)),
                                density: "compact"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_radio, {
                                    label: "Raw",
                                    value: "raw",
                                    class: "text-caption"
                                  }),
                                  _createVNode(_component_v_radio, {
                                    label: "Basic",
                                    value: "basic",
                                    class: "text-caption"
                                  }),
                                  _createVNode(_component_v_radio, {
                                    label: "Full",
                                    value: "full",
                                    class: "text-caption"
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_btn, {
                color: "primary",
                class: "expand-btn mt-n1",
                variant: "text",
                icon: _ctx.show ? 'mdi-chevron-up' : 'mdi-chevron-down',
                onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.show = !_ctx.show; _ctx.$emit('contentUpdated')})
              }, null, 8, ["icon"])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_v_expand_transition, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_text, {
          class: _normalizeClass({ 'truncated-text': !_ctx.show })
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              (Array.isArray(_ctx.content))
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.content, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `content-${index}`
                      }, [
                        (item.type === 'text' && item.text)
                          ? (_openBlock(), _createBlock(_component_Markdown, {
                              key: 0,
                              msg: item.text
                            }, null, 8, ["msg"]))
                          : _createCommentVNode("", true),
                        (item.type === 'image' && item.image)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 1,
                              src: `data:${item.image.mimeType};base64,${item.image.base64Data}`,
                              class: "content-image"
                            }, null, 8, _hoisted_3))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : (_ctx.text !== '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      (_ctx.formatting !== 'full')
                        ? (_openBlock(), _createElementBlock("p", {
                            key: 0,
                            class: _normalizeClass(_ctx.formatting === 'basic' ? 'format-text' : '')
                          }, _toDisplayString(_ctx.text), 3))
                        : _createCommentVNode("", true),
                      (_ctx.formatting === 'full')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            (_ctx.thinking !== '')
                              ? (_openBlock(), _createBlock(_component_v_expansion_panels, {
                                  key: 0,
                                  density: "compact",
                                  class: "mb-4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_expansion_panel, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_expansion_panel_title, { class: "text-overline thinking pa-2" }, {
                                          default: _withCtx(() => _cache[4] || (_cache[4] = [
                                            _createTextVNode("Thinking")
                                          ])),
                                          _: 1,
                                          __: [4]
                                        }),
                                        _createVNode(_component_v_expansion_panel_text, null, {
                                          default: _withCtx(() => [
                                            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.thinking), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chunks, (chunk, index) => {
                              return (_openBlock(), _createElementBlock("div", { key: index }, [
                                (chunk.code)
                                  ? (_openBlock(), _createBlock(_component_CodeBlock, {
                                      key: 0,
                                      code: chunk.text,
                                      language: chunk.language,
                                      lineStart: _ctx.lineStart
                                    }, null, 8, ["code", "language", "lineStart"]))
                                  : (_openBlock(), _createBlock(_component_Markdown, {
                                      key: 1,
                                      msg: chunk.text
                                    }, null, 8, ["msg"]))
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _: 1
    })
  ]))
}